import React, { useEffect, useState } from 'react';
import { FilterProps } from '../../../common/filter.util';
import { Divider, Grid } from '@mui/material';
import { DeleteIcon } from '../../../../../icons/Delete/DeleteIcon';
import { VentoryColor } from '../../../../../util/color.util';
import MultiSelectionList from '../../../../common/MultiSelectionList/MultiSelectionList';
import SearchBar from '../../../../common/SearchBar/SearchBar';
import { CustomFieldEntitySubType, CustomFieldUtil } from '../../../../../../types/custom_field';
import { CustomFieldEntitySubTypeFilter } from '../CustomFieldEntitySubTypeFilter';

interface CustomFieldEntitySubTypeFilterDropdownContentProps {
  filter: CustomFieldEntitySubTypeFilter;
  filterProps: FilterProps;
  setFilterProps: (filter: FilterProps) => void;
}

export function CustomFieldEntitySubTypeFilterDropdownContent({
  filter,
  filterProps,
  setFilterProps,
}: CustomFieldEntitySubTypeFilterDropdownContentProps) {
  const [query, setQuery] = useState<string>('');

  const filterCustomFieldEntitySubtype = () => {
    return new Set(
      filter.filteredItems([...Object.values(CustomFieldEntitySubType)], query, filterProps).map(item => item),
    );
  };

  const [values, setValues] = useState<Set<string>>(filterCustomFieldEntitySubtype());

  const handleChange = (selected: Set<string>) => {
    filterProps.customFieldEntitySubType = selected;
    if (!filterProps.customFieldEntitySubType?.size) filterProps.customFieldEntitySubType = undefined;
    setFilterProps({ ...filterProps });
  };

  const handleRemove = () => {
    filterProps.customFieldEntitySubType = undefined;
    setFilterProps({ ...filterProps });
  };

  useEffect(() => {
    setValues(filterCustomFieldEntitySubtype());
  }, [query]);

  return (
    <Grid container>
      <Grid item xs={12} className='flex px-3 py-2'>
        <Grid container>
          <Grid item>
            <p className='text-ventory-grey-500 text-[13px] font-[500]'>{filter.toLabel()}</p>
          </Grid>
          <Grid item flexGrow={1} display={'flex'} justifyContent={'flex-end'} sx={{ color: VentoryColor.deleteRed }}>
            <Grid item onClick={handleRemove} className='cursor-pointer'>
              <DeleteIcon />
            </Grid>
          </Grid>
        </Grid>
      </Grid>
      <Grid item xs={12}>
        <SearchBar onChange={i => setQuery(i)} className='pl-3 pr-4' />
      </Grid>
      <Grid item className='py-3' xs={12}>
        <Divider />
      </Grid>
      <Grid item xs={12}>
        <MultiSelectionList
          selected={filterProps.customFieldEntitySubType}
          values={values}
          onChange={handleChange}
          toText={id => CustomFieldUtil.customFieldEntitySubtypeToString(id as CustomFieldEntitySubType)}
        />
      </Grid>
    </Grid>
  );
}
